module.exports = __webpack_public_path__ + "static/media/top_infographic_desktop.89b70f97.webp";